import 'polyfills';
import Application from 'ef_sdk';
import routes from 'routes';
import extensions from 'extensions';
import Chaplin from 'chaplin';
import _ from 'lodash';
import 'imports';
import Handlebars from 'handlebars/runtime';

/* The handlebars compiler in handlebars-brunch adds a call to window.Handlebars.
   This is shimmed in the SDK in brunch-config, but components still need it
   To remove this global, make sure the components don't call it, then remove this next line */
window.Handlebars = Handlebars;

/* Foundry, and Scorm packages rely on window.Chaplin, there is a ticket to remove this: CS-3916 */
window.Chaplin = Chaplin;

if (extensions !== undefined) {
  extensions();
}

const initialize = {
  configure: function (options) {
    options = options || {};
    const appConfig = {
      routes: routes,
      controllerPath: '',
      controllerSuffix: '-controller',
      pushState: false,
    };
    options = _.extend(appConfig, options);
    const app = new Application(options);
    window.onerror = () => {
      Chaplin.mediator.publish('application:error', app);
    };
    return app;
  },
};

module.exports = initialize;
